import React from 'react'
import colors from '../../constants/colors'
import Flex from '../Flex'
import Icon from '../Icon'
import { sizeVariant } from './variant'
import { ChipProps } from './Chip.types'
import styled from 'styled-components'

const StyledFlex = styled(Flex)<ChipProps>`
  ${sizeVariant}
`

const index: React.FC<ChipProps> = ({
  backgroundColor = 'white',
  color = 'black75',
  borderColor = 'black10',
  label,
  onDelete,
  onClick,
  size = 'default',
  ...props
}) => {
  return (
    <StyledFlex
      borderRadius='12px'
      backgroundColor={backgroundColor}
      justifyContent='center'
      alignItems='center'
      border={`0.75px solid ${colors[borderColor]}`}
      gap='8px'
      cursor={onClick ? 'pointer' : 'default'}
      onClick={onClick}
      size={size}
      color={color}
      {...props}
    >
      {label}
      {onDelete && (
        <Icon name='Close-outline' color={color} size='18px' cursor='pointer' onClick={onDelete} />
      )}
    </StyledFlex>
  )
}

export default index
